window.SampleEventDelegate = function(){

    this.sessionEnded = function(config){
        $('#personetics-insights-container').show();
        $('#personetics-story-container').hide();
        myApp.startPersonetics();
    };

    this.registered = function() {

    };

    this.sessionStarted = function(){

    };
    this.navigateToPage = function(params){
        var data = {
            requestString: "navigateToPage",
            data: params
        };
        this.sendRequestToPServer(null, data);  
    };
    this.sessionError = function(error){

    };

    this.widgetEvent = function widgetEvent(widget, params) {

        var eventType = params.eventType;
        switch (eventType) {
            case "teaserClick":
                params.filter = true;
                var channel = personetics.getDeviceType();
                if ( channel === 'RJS') {
                    var data = {
                        requestString: "personeticsEvent",
                        data: params
                    };
                    this.sendRequestToPServer(null,data);
                }else{
                    samplePage.master.openModule("inbox",params);
                }
                break;
            case "reporting":
                var channel = personetics.getDeviceType();
                if (channel === 'RJS') {
                    var data = {
                        requestString: "personeticsEvent",
                        data: params
                    };
                    this.sendRequestToPServer(null, data);
                }
                break;
        }
    };

    /**
     * Send data to native interface
     * @param requestId
     * @param postData
     */
    this.sendRequestToPServer = function(requestHeader, data, requestId){
        Personetics.utils.PLogger.debug("Personetics Events Delegate requestDataFromNative: " + JSON.stringify(data) + ", requestId: " + requestId);
        var requestString = data.hasOwnProperty("requestString") ? data.requestString : "sendRequestToPServer";
        var json = {requestData: data, requestId: requestId};
        var channel = personetics.getDeviceType();
        if (channel === 'RJS') {
            window.PersoWidget.widgetEventHandler({requestHeader,json, requestString, requestId});
        }else{
            myApp.sendRequestToPServer(
                requestHeader,
                data,
                function(response) {
                    personetics.handlePServerResponse(response, requestId);
                }
            );
        }
    };
};